// extracted by mini-css-extract-plugin
export default {"gift_cards_delivery":"GiftCardsDelivery_gift_cards_delivery__Q3sMr","set_date":"GiftCardsDelivery_set_date__o3Nj-","submit_error":"GiftCardsDelivery_submit_error__52or3"};